module.exports = __webpack_public_path__ + "media/images/logo-carte_bleue_visa_mastercard-b08aa65bb95119293c9109ae1d037c7c.svg";